export default __webpack_public_path__ + "static/nuggs-744eeb07bca0b427d059c39293786ae8.png";